import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AdminQuizTable } from '../../../components/admin/AdminQuizTable'

/**
 * Admin all-quizzes view (`/admin/quizzes`) — survey quizzes across every org
 * (read-only oversight). Guarded by {@link useRequireAdmin}.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/quizzes',
  component: AdminQuizzesPage,
})

function AdminQuizzesPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <AdminShell active="quizzes" title={t('quizzesAllTitle')}>
      <AdminQuizTable />
    </AdminShell>
  )
}
